import api from './api';

const comunicadoService = {
  get: async () => {
    const response = await api.get('/comunicado-modal');
    return response.data?.data;
  },
  update: async (data) => {
    const response = await api.post('/comunicado-modal', data);
    return response.data?.data;
  }
};

export default comunicadoService;
